import PropTypes from 'prop-types';

export const noOfNights = (day1, day2) => (day1 - day2) / (24 * 60 * 60 * 1000);
export const titlesMap = [
  {name: 'Mr', value: '1'},
  {name: 'Mrs', value: '2'},
  {name: 'Master', value: '3'},
  {name: 'Miss', value: '4'},
];

export const formValidator = ({value, type, cc = ''}) => {
  let regex;
  switch (type) {
    // this regex allows all characters.
    case 'name':
    case 'fname':
    case 'lname':
    case 'gstCountry':
    case 'gstState':
    case 'companyName':
    case 'travellersPanName':
      regex = /^[a-zA-Z '~!]{1,}$/;
      // [a-zA-Z0-9 '~!] => characters we want to match (customize as required)
      // {1,} match minimum 1 and maximum any number of characters from the previously defined class
      // $ end of the string
      break;
    case 'mname':
    case 'companyAddress':
    case 'travellersPanTime':
      regex = /^[^]+$/;
      break;
    // regex for gstNumber: either of pattern 22AAAAA0000A1Z5 or an empty string. Empty string because gst number is optional.
    case 'gstNumber':
      regex = /^(\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d{1}[Z]{1}[A-Z\d]{1}|^)$/;
      break;
    case 'mobile':
    case 'companyPhone':
    case 'gstPhoneNumber':
      // check for international
      if (cc && cc !== '+91' && cc !== '91') {
        regex = /^\d+$/;
      } else {
        regex = /^\d{10}$/;
      }
      break;
    case 'mobileInt':
    case 'gstPhoneNumberInt':
      regex = /^\d+$/;
      break;
    case 'email':
    case 'businessEmail':
    case 'companyEmail':
      regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      break;
    case 'profileType':
      regex = /^(Personal|Business)$/i;
      break;
    case 'title':
      regex = /^(Mr|Ms|Mrs)$/i;
      break;
    case 'pan':
      regex = /^[a-zA-Z]{5}\d{4}[a-zA-Z]{1}$/;
      break;

    default:
      return false;
  }

  return regex.test(value);
};

noOfNights.propTypes = {
  day1: PropTypes.instanceOf(Date),
  day2: PropTypes.instanceOf(Date),
};
